module.exports = __webpack_public_path__ + "static/img/hover-iocn81.f3603cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/add_icon/hover-iocn81.png
// module id = hziE
// module chunks = 0